var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPound(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 21.102a9 9 0 110-18 9 9 0 010 18z",
    stroke: "#98ACC2",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 15.533h1.554v-3.345H8v-1.284h1.554V9.376c0-.376.066-.763.198-1.16.132-.398.34-.76.625-1.085.285-.337.65-.606 1.097-.81.447-.214.986-.321 1.615-.321.55 0 1.077.081 1.585.244.508.153.95.398 1.326.734l-1.234 1.329a2.574 2.574 0 00-.732-.474 2.08 2.08 0 00-.884-.183c-.284 0-.538.056-.761.168-.214.102-.397.24-.549.413-.152.173-.27.371-.35.595a2.31 2.31 0 00-.107.703v1.375h2.468v1.284h-2.468v3.345h3.855V17H8v-1.467z"
  })));
}
export default SvgIconPound;